import { Directive, ElementRef, Inject, OnInit } from '@angular/core';
import { componentStylesByTheme } from '../../../utils/theme.utils';
import { THEME_TOKEN, Theme } from '../../../types/theme.types';
import { tableCellStylesSAG, tableCellStylesSHS } from './table-cell.styles';
import { style } from '../../../utils/style.utils';

@Directive({
  selector: 'td[sag-ui-td]',
})
export class TableCellDirective implements OnInit {
  constructor(
    @Inject(THEME_TOKEN) private readonly theme: Theme,
    private readonly elementRef: ElementRef<HTMLInputElement>
  ) {}

  ngOnInit(): void {
    const inputStyles = componentStylesByTheme(
      this.theme,
      tableCellStylesSAG,
      tableCellStylesSHS
    );
    style(this.elementRef, inputStyles());
  }
}
